import { css } from 'styled-components';
import { LegalProps } from './models';

export const Legal = css<LegalProps>(({ theme }) => {
  return css`
    text-align: left;

    @media only screen and ${theme.device.mobileXL} {
      text-align: center;
    }

    > .text {
      font-weight: 400;
      font-size: 10px;
      line-height: 15px;
      color: ${theme.colors.darkGray};
    }
  `;
});
